/* Token storage — access (30 min) + rotating refresh (single-use).
   localStorage + Authorization header (no cookies). */

const A = 'miya_access',
  R = 'miya_refresh';

export const getAccess = () => localStorage.getItem(A) || '';
export const getRefresh = () => localStorage.getItem(R) || '';

/* save from a login/refresh response: {access_token, refresh_token} */
export function saveTokens(d) {
  if (d.access_token) localStorage.setItem(A, d.access_token);
  if (d.refresh_token) localStorage.setItem(R, d.refresh_token); // ROTATED — always replace
}
export function clearTokens() {
  localStorage.removeItem(A);
  localStorage.removeItem(R);
}
export const hasSession = () => !!getRefresh() || !!getAccess();
